// MenuListItem ending button types
export const MENU_LIST_ITEM_ENDING_BUTTON_TYPE_SWITCH = 'switch';
export const MENU_LIST_ITEM_ENDING_BUTTON_TYPE_RADIO = 'radio';
export const MENU_LIST_ITEM_ENDING_BUTTON_TYPE_CHECKBOX = 'checkbox';
export const MENU_LIST_ITEM_ENDING_BUTTON_TYPE_ICON_BUTTON = 'iconButton';

// Badge color constants
export const INLINE_BADGE_BACKGROUND_COLOR = 'tertiaryFixedDim';
export const INLINE_BADGE_TEXT_COLOR = 'onTertiary';
